import React, { useState } from "react";
import styles from "./auth.module.css";
import { images, icons } from "assets";
import Text from "Components/shared/text";
import FormControl from "Components/shared/control";
import { InputWithAdornment } from "Components/shared/inputs";
import Button from "Components/shared/button";
import { Link, useNavigate } from "react-router-dom";
import useForm from "hooks/useForm";
import validateLogin from "utils/validators/login";
import { loginAction } from "services/authService";
import {
  ERROR_OCCUR,
  INIT_LOGIN,
  LOGIN_SUCCESS,
  useAuthDispatch,
  useAuthStore,
} from "providers/auth";
import { ErrorModal } from "Components/shared/successful/ErrorModal";
const Login = () => {
  const navigate = useNavigate();
  const authDispatch = useAuthDispatch();
  const { error } = useAuthStore();

  const [errorModal, setErrorModal] = useState(error?.message);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const loginHandler = async (values, { setIsSubmitting, resetValues }) => {
    try {
      authDispatch({
        type: INIT_LOGIN,
      });
      setErrorModal(false);
      const {
        data: { status, message, data },
        status: statusCode,
      } = await loginAction(values);

      if (status === "Ok" || statusCode === 200) {
        authDispatch({
          type: LOGIN_SUCCESS,
          token: data.accessToken,
          userId: data.id,
          profile: data.profile,
          sessionKey: data.sessionKey,
          todo: data.todo,
        });
        resetValues();
      }
    } catch (err) {
      authDispatch({
        type: ERROR_OCCUR,
        error: err,
      });
      setErrorModal(true);
    } finally {
      setIsSubmitting(false);
    }

    navigate("/", { replace: true });
  };
  const { handleUpdate, handleSubmit, values, errors, touched, isSubmitting } =
    useForm({
      initialState: {
        email: "",
        password: "",
      },
      onSubmitHandler: loginHandler,
      validate: validateLogin,
    });

  return (
    <div className={styles.root}>
      <div className={styles.Left}>
        <div>
          <img src={icons.logo} alt="company logo" />
        </div>
        <div className={styles.FormContainer}>
          <Text tag="h1" style={{ fontWeight: 800 }} variant="xxl">
            Welcome back.
          </Text>
          <Text color="secondary" variant="md">
            Enter your registered mobile number to log in.
          </Text>
          <form className={styles.Form} onSubmit={handleSubmit}>
            <FormControl
              label="Email Address"
              name="email"
              error={errors.email && touched.email && errors.email}
              fullWidth
            >
              <InputWithAdornment
                type="email"
                fullWidth
                right={<img src={icons.envelope} alt="mail" />}
                placeholder="Enter your email address"
                value={values.email}
                {...handleUpdate()}
              />
            </FormControl>
            <FormControl
              label="Password"
              name="password"
              id="password"
              error={errors.password && touched.password && errors.password}
              fullWidth
            >
              <InputWithAdornment
                type={isPasswordVisible ? "text" : "password"}
                placeholder="Enter a secure password"
                fullWidth
                right={
                  <img
                    onClick={(e) => setIsPasswordVisible((prev) => !prev)}
                    src={isPasswordVisible ? icons.eye_close : icons.open_eye}
                    width="16px"
                    height="16px"
                    alt="make visible"
                    style={{ cursor: "pointer" }}
                  />
                }
                {...handleUpdate()}
                value={values.password}
              />
            </FormControl>
            <div className={styles.ForgotPassword}>
              <Text color="primary" variant="sm">
                <Link to="forgot-password">Forgot Password?</Link>
              </Text>
            </div>
            <FormControl fullWidth>
              <Button
                label="Login"
                disabled={!!(errors.email || errors.password)}
                type="submit"
                fullWidth
                loading={isSubmitting}
              />
            </FormControl>
            <ErrorModal
              message={error?.message}
              setErrorModal={setErrorModal}
              openModal={errorModal}
            />
          </form>
          <div className={styles.Option}>
            <Text variant="sm" color="secondary">
              Or Login with
            </Text>
          </div>
          <div className={styles.Social}>
            <Button color="primary">
              <Text style={{ color: "var(--social-color)" }}>Facebook</Text>
              <img
                src={icons.facebook}
                alt="facebook"
                style={{ marginLeft: "8px" }}
              />
            </Button>
            <Button color="primary">
              <Text style={{ color: "var(--social-color)" }}>Google</Text>
              <img
                src={icons.google}
                alt="google"
                style={{ marginLeft: "8px" }}
              />
            </Button>
          </div>
          <Text color="secondary" className="w-full text-center">
            Don’t have an account?{" "}
            <Link
              to="sign-up"
              style={{ color: "var(--secondary-color)" }}
              className="hover:link"
            >
              Sign up
            </Link>
          </Text>
        </div>
      </div>
      <div className={styles.Right}>
        <img src={images.rightImage} alt="right" />
      </div>
    </div>
  );
};

export default Login;
